module.exports = __webpack_public_path__ + "static/media/fn2.31affd45.png";